/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchaseOrder } from '../../models/purchase-order';
import { ValidationWithComment } from '../../models/validation-with-comment';

export interface PatchPurchaseOrderAmountValidation$Params {
  uuid: string;
      body: ValidationWithComment
}

export function patchPurchaseOrderAmountValidation(http: HttpClient, rootUrl: string, params: PatchPurchaseOrderAmountValidation$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseOrder>> {
  const rb = new RequestBuilder(rootUrl, patchPurchaseOrderAmountValidation.PATH, 'patch');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PurchaseOrder>;
    })
  );
}

patchPurchaseOrderAmountValidation.PATH = '/purchase-orders/{uuid}/admin';
